import React from "react";

/**
 * Modal d'avertissement avant la déconnexion automatique.
 * S'affiche uniquement quand `open` est vrai.
 */
export default function IdleLogoutWarning({ open, remainingMs, onStay, onLogoutNow }) {
  if (!open) return null;
  const seconds = Math.max(0, Math.ceil(remainingMs / 1000));
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm"
      data-testid="idle-logout-warning"
      role="alertdialog"
      aria-live="assertive"
    >
      <div className="max-w-md w-[92%] mx-auto rounded-2xl border border-amber-400/40 bg-zinc-950 p-6 shadow-2xl">
        <div className="flex items-start gap-3">
          <div className="text-3xl" aria-hidden>⏰</div>
          <div className="flex-1">
            <h2 className="text-lg font-bold text-amber-300 mb-1">
              Session sur le point d'expirer
            </h2>
            <p className="text-sm text-zinc-300">
              Pour votre sécurité, vous serez déconnecté(e) automatiquement dans{" "}
              <span className="font-mono font-bold text-amber-200" data-testid="idle-logout-seconds">
                {seconds}
              </span>{" "}
              secondes en raison de votre inactivité.
            </p>
          </div>
        </div>
        <div className="mt-5 flex flex-col sm:flex-row gap-2 sm:justify-end">
          <button
            type="button"
            onClick={onLogoutNow}
            className="btn-ghost px-4 py-2 rounded-lg text-sm border border-white/10 hover:bg-white/5"
            data-testid="idle-logout-now-btn"
          >
            Se déconnecter maintenant
          </button>
          <button
            type="button"
            onClick={onStay}
            className="btn-primary px-4 py-2 rounded-lg text-sm"
            data-testid="idle-logout-stay-btn"
            autoFocus
          >
            Rester connecté(e)
          </button>
        </div>
      </div>
    </div>
  );
}
